import { render } from "./FacebookIcon.vue?vue&type=template&id=b7542636"
import script from "./FacebookIcon.vue?vue&type=script&lang=js"
export * from "./FacebookIcon.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__